import { PublicKey } from '@solana/web3.js';

class Pda extends PublicKey {
  /** The bump used to generate the PDA. */

  constructor(value, bump) {
    super(value);
    this.bump = bump;
  }
  static find(programId, seeds) {
    const [publicKey, bump] = PublicKey.findProgramAddressSync(seeds, programId);
    return new Pda(publicKey, bump);
  }
}

export { Pda };
//# sourceMappingURL=Pda.mjs.map
